import React from 'react';
import { Formik } from 'formik';
import { Form as SForm } from 'semantic-ui-react';
import * as Lookups from '../../../Hooks/LookupOptions';
import { IdentificationDocSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { IdentificationSearchSchema } from './IdentificationForm.Schema';
import SemanticFormikSelect from '@app/components/React/Common/Forms/SemanticFormikSelect';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface Props {
    currentParams: IdentificationDocSearchDto;
    setCurrentParams: (p: IdentificationDocSearchDto) => void;
    onChange?: (params: IdentificationDocSearchDto) => void;
}

export default function IdentificationForm({ currentParams, setCurrentParams, onChange }: Props) {
    const { items: ID_TYPE_OPTIONS } = Lookups.useIdTypeOptions({ defaultValue: currentParams.idType });
    const discriminator = SEARCH_TYPES_NAMES.IdentificationDocSearchDto;

    const initialValues: IdentificationDocSearchDto = {
        discriminator,
        operator: currentParams.operator,
        idNumber: currentParams.idNumber || '',
        idType: currentParams.idType,
        country: currentParams.country || '',
        stateOfIssuance: currentParams.stateOfIssuance || '',
    };

    const handleSubmit = (values: IdentificationDocSearchDto) => {
        setCurrentParams({ ...values, discriminator });
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={IdentificationSearchSchema}
            onSubmit={handleSubmit}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
        >
            {({ handleSubmit, values }) => (
                <>
                    <ChangeObserver value={values} onChange={onChange} />

                    <FormWithButtons handleSubmit={handleSubmit}>
                        <SForm.Group widths="equal">
                            <SemanticFormikSelect
                                name="idType"
                                label="ID Type"
                                placeholder="e.g., passport"
                                options={ID_TYPE_OPTIONS}
                                required
                            />
                            <SemanticFormikInput
                                name="idNumber"
                                label="ID Number"
                                placeholder="Enter ID number"
                            />
                        </SForm.Group>
                        <SForm.Group widths="equal">
                            <SemanticFormikInput
                                name="country"
                                label="Country"
                                placeholder="Enter country"
                            />
                            <SemanticFormikInput
                                name="stateOfIssuance"
                                label="State of Issuance"
                                placeholder="Enter state of issuance"
                            />
                        </SForm.Group>
                    </FormWithButtons>
                </>
            )}
        </Formik>
    );
}
